import { Injectable, NgModule } from '@angular/core';
import { Resolve, RouterModule, Routes } from '@angular/router';

import { VendorsHomePage } from './vendors-home.page';

import { NavigationService } from '../../core/services/navigation.service';

export interface VendorsHomePageParams {
  readonly selectedServiceType?: number;
}

@Injectable({ providedIn: 'root' })
class VendorsHomePageParamsResolver implements Resolve<VendorsHomePageParams> {
  constructor(private navigationService: NavigationService) {}

  resolve(): VendorsHomePageParams {
    if (!this.navigationService.isNavigatingBack()) {
      return this.navigationService.getCurrentNavigationStateParams<VendorsHomePageParams>();
    }
  }
}

const routes: Routes = [
  {
    path: '',
    component: VendorsHomePage,
    resolve: { pageParams: VendorsHomePageParamsResolver },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VendorsHomePageRoutingModule {}
